import { DwOrmData } from "@devwareapps/devware-cap";
import { SchoolAssignmentStatEntity } from "./school-assignment-stat-entity.model";

export interface SchoolStatEntity extends DwOrmData { 
    FlightSchoolId : number
    ActiveStudents: number;
    CompletedStudents: number;
    AverageProgress: number;
    AverageCompletionTime: number;
    ACSAverageFirstTimePassRate: number;
    ACSAwaitingUpload: number;
    ACSTestUploaded: number;
    ACSTestAverageScore: number;
    RoSchoolAssignmentStats? : SchoolAssignmentStatEntity;
}

export enum SchoolStatAggregateFields {
    ActiveStudents= 'ActiveStudents',
    CompletedStudents= 'CompletedStudents',
    AverageProgress= 'AverageProgress',
    AverageCompletionTime = 'AverageCompletionTime',
    ACSAverageFirstTimePassRate = 'ACSAverageFirstTimePassRate',
    ACSTestUploaded = 'ACSTestUploaded',
    ACSAwaitingUpload = 'ACSAwaitingUpload',
    ACSTestAverageScore = 'ACSTestAverageScore',
}